<template>
  <v-btn @click="createCategory" color="primary" target="_blank" elevation="0">
    <v-icon left>mdi-plus</v-icon>
    <span class="d-none d-md-flex body-2">
      {{ $t('category.action.create') }}
    </span>
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'CategoryHeaderActions',

  methods: {
    ...mapActions(['handleOpenCreateCategoryModal']),

    createCategory() {
      this.handleOpenCreateCategoryModal()

      const createCategoryModal = this.$parent?.$parent?.$refs.rentOutRouterView?.$refs.createCategory
      this.$nextTick(() => createCategoryModal.resetCategoryFields())
    },
  },
}
</script>
